import { callAPI } from "utils/API";
import { AppContext } from "contexts/AppContext";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Video, { getVideoType } from "components/elements/Video";
import Image from "components/elements/Image";
import Headline3 from "components/elements/Headline3";
import ContentNormal from "components/elements/ContentNormal";
import "./PostDetails.css"
import _ from 'lodash'
import { RawHTML } from "utils/general";
import CustomCarousel from "components/blocks/customCarousel/CustomCarousel";
import { Input } from "@mui/material";
import ContentLarge from "components/elements/ContentLarge";
import Headline2 from "components/elements/Headline2";
import IconButtonMedium from "components/elements/IconButtonMedium";
import Save from '@mui/icons-material/Save';
import ArrowRight from "components/icons/ArrowRight";
import ExplainerText from "components/elements/ExplainerText";
import ExplainerTextTiny from "components/elements/ExplainerTextTiny";
import SectionWrapper from "components/layouts/SectionWrapper";

const PostDetails = (props) => {
  const {postType=""} = props 
  const { styleGuide, defaultTheme, brandData } = useContext(AppContext);
  const { PostID } = useParams()
  const [postDetails, setPostDetails] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [postContent, setPostContent] = useState(null);
  const [postTitle, setPostTitle] = useState(null);
  const [imgHeight,setImgHeight]=useState()
  const navigate = useNavigate();

  const fetchPostDetails = async (id) => {
    if(isNaN(id)) return 
    let postDetails = await callAPI(`/posts/${id}`, "GET");
    if (postDetails) {
      if(postDetails.blogType === "FAQ") {
        navigate("/help", {state: {PostID: postDetails.PostID}})
      }
      if (postDetails.attachments && Array.isArray(postDetails.attachments)) {
        postDetails.imageURL = !!postDetails.attachments.length ? postDetails.attachments[0].imageOriginSource : 'https://i.imgur.com/qtmXhnZ.jpg';
      }
      setPostDetails(postDetails);
      return
    }
    setPostDetails({})
    return
  }

  const isVideo = (attachments) => {
    const videoAttachment = attachments.filter(item => item.LinkID && item.linkRef);
    return videoAttachment.length ? true : false;
  }

  const getVideoLink = (attachments) => {
    const videoAttachment = attachments.filter(item => item.LinkID && item.linkRef);
    const link = videoAttachment.length ? videoAttachment[0].linkRef : null
    const videoInfo = getVideoType(link)
    return videoInfo ? videoInfo.url : null
  }

  useEffect(() => {
    fetchPostDetails(PostID)
  }, [PostID]);

  useEffect(() => {
    if(postDetails){
      if(postDetails.attachments && Array.isArray(postDetails.attachments)) {
        setImageUrl(postDetails.bannerImage || (!!postDetails.attachments.length && postDetails.attachments[0].imageOriginSource ? postDetails.attachments[0].imageOriginSource : 'https://i.imgur.com/qtmXhnZ.jpg'))
        setVideoUrl(!!postDetails.videoSrc ? postDetails.videoSrc : isVideo(postDetails.attachments) ? getVideoLink(postDetails.attachments) : null)  
      }
      setPostContent(postDetails.elementContent)
      setPostTitle(postDetails.elementTitle)
    }
  }, [postDetails]);

  useEffect(() => {
    let Width = window.screen.width
    setImgHeight(Width / 2)
  }, []);

  useEffect(() => {
    window.addEventListener('resize', _.debounce(() => {
        let imgWidth = window.screen.width
        setImgHeight(imgWidth / 2)
    }, 200));
    return () => {
      window.removeEventListener('resize', _.debounce(() => {
          let imgWidth = window.screen.width
          setImgHeight(imgWidth / 2)
      }, 200));
    }
},[imageUrl])


  if (!postDetails) return <div />
  const bannerStyle1 = { display: 'flex', width: '100%', height: !!imageUrl? imgHeight : null,flexDirection: 'column', maxHeight: styleGuide.bannerMaxHeight }
  const bannerStyle = defaultTheme == 'ThemeONE' ? { ...bannerStyle1 } : defaultTheme == 'ThemeTWO' ? { ...bannerStyle1, marginTop: '-180px' } : { ...bannerStyle1,marginTop: '-20px' };

  return (
    <SectionWrapper>
      {/* {postDetails && JSON.stringify(postDetails)} */}
      <div style={bannerStyle}>
        <div>
          {
            !!imageUrl
              ? <div style={{height:imgHeight, width:'100%', overflow: 'hidden', position:'absolute', left:0, right:0, maxHeight: styleGuide.bannerMaxHeight}}>
                <Image src={`url(${imageUrl})`}
                  style={{
                    width: '100%',
                    height:'100%',
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                  }}
                />
                </div>
              : null
          }
        </div>
        </div>
        <div style={{ marginTop: '50px'}} >
        <Headline3 style={{ fontSize: 40, lineHeight: '60px',wordBreak:'break-word'}} >{postTitle}</Headline3>
        <div style={{display:'flex', flexDirection: 'row', marginTop: 40, gap: "1.5rem"}}>

          <div className={postType !== "taxCampaign" ? "post-content" : "post-campaign-content"} style={{display:'flex'}}>
            <ContentNormal>
              <div style={{wordBreak:'break-word'}}>
                {/* <span>{newLineToBreakTag(parseLinks(postContent))}</span> */}
                <RawHTML>
                  {postContent}
                </RawHTML>                
                {
                  !!videoUrl 
                    ? <Video url={videoUrl} style={{width: "100%", marginTop: "2rem" }} />
                    : null
                }
              </div>
            </ContentNormal> 
          </div>
          {
            !!postDetails?.attachments?.length && <div style={{width:"100%", flex:0.4}}>
            <CustomCarousel>
              {
                !!(postType === "taxCampaign") && postDetails?.attachments?.map((item, index) => 
                <Image 
                  key={index} 
                  src={`url(${item.imageOriginSource})`}
                  style={{
                    width: "100%",
                    height: 700,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    cursor:"pointer"
                  }}
                  onClick={()=> {}}
                />
              )}
            </CustomCarousel>
            </div>
          }
        </div>
        </div>
        {
            !!(postType === "taxCampaign") && 
            !!postDetails?.additionalInput && <>
            {
              // TO DO : this should be moved to Admin as config/customisation; 
              // Having specific BrandIDs in code is not recommended.
              // It is done this way to get things to Live urgently.
              brandData?.BrandID === 32 
                ? <AdditionalInputFieldsV3 additionalInput={JSON.parse(postDetails?.additionalInput)} />
                : brandData?.BrandID === 187
                  ? <AdditionalInputFieldsV4 additionalInput={JSON.parse(postDetails?.additionalInput)} />
                  : <AdditionalInputFieldsV2 additionalInput={JSON.parse(postDetails?.additionalInput)} />
            }
            </>
          }
    </SectionWrapper>
  );
};

export default PostDetails;

export const AdditionalInputFieldsV1 = (props) => {
  const {additionalInput} = props
  const {captionText=" ", data=[]} = additionalInput
  const {brandData, userData, styleGuide, setUserData} = useContext(AppContext)
  const brandPointRatio = brandData?.brandPointRatio || null
  // const userTaxPercentage = userData?.taxPercentage || null
  const [rows, setRows] = useState([])

  const defaultPrice = Number(0).toLocaleString("da-DK", { style: "currency", currency: "DKK" })
  const [enteredPercentage, setEnteredPercentage] = useState(userData?.taxPercentage || 0)
  const [enteredPrice, setEnteredPrice] = useState(0)
  const [calculatedExternalPrice, setCalculatedExternalPrice] = useState(defaultPrice)
  const [calculatedInternalPrice, setCalculatedInternalPrice] = useState(defaultPrice)

  const submitTaxPercentage = async() => {
    if(!enteredPercentage) return
    const taxPercentage = enteredPercentage
    const response = await callAPI("/user/saveTaxPercentage", "POST", { body: { taxPercentage: taxPercentage } })
    if (response) {
        setUserData({ ...userData, taxPercentage: taxPercentage })
    }    
  }

  useEffect(() => {
    if(data?.length){
      setRows(data?.map(a => {
        a.calculatedDKK = Number(a.valueType === 'pt' ? a.inputValue / brandPointRatio : a.inputValue)
        a.calculatedTaxValue = !enteredPercentage ? 'xx.xx' : Number(a.calculatedDKK * (1 - enteredPercentage/100))
        a.inputValue = Number(a.inputValue)
        return a
      }))
    }
  },[enteredPercentage])

  useEffect(() => {
    if(!enteredPrice || !enteredPercentage) { 
      setCalculatedExternalPrice(defaultPrice)
      setCalculatedInternalPrice(defaultPrice)
    } else {
      const percentage = 1 - (enteredPercentage/100)
      const extPrice = !enteredPrice || !enteredPercentage ? defaultPrice : Number(enteredPrice / percentage)?.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
      const intPrice = !enteredPrice || !enteredPercentage ? defaultPrice : Number(enteredPrice * percentage)?.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
      setCalculatedExternalPrice(extPrice)
      setCalculatedInternalPrice(intPrice)
    }
  },[enteredPercentage, enteredPrice])

  return !data ? null : <>
      <div 
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: 50
      }}
    >
      {/* blue box */}
      <div
        style={{
          display: "flex",
          background: "#235c76" || styleGuide.color16,
          padding: "35px 40px",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast din trækprocent" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPercentage}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPercentage(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="%" style={{color: "white"}} />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast prisen på dit køb" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue=""
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPrice(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="kr" style={{color: "white"}} />
          </div>
        </div>
        <IconButtonMedium
          title="Gem procent til profil"
          style={{ marginLeft: 8, height: 50, width: 50, borderRadius: 20 }}
          onClick={submitTaxPercentage}
          icon={
            <Save
              fill='white'
              style={{ height: 30, width: 30 }}
              stroke="#bf150a"
              strokeWidth="1.5px"
            />
          }
        />
      </div>

      {/* red box */}
      <div style={{ background: "#bf150a", display: "flex", padding: "35px 40px", flexWrap: "wrap", gap: "2rem", alignItems: "center" }} >
        <ContentLarge fallbackText="Din pris efter skat gennem Tryg klubben" style={{color: "white"}} />
        <div className='arrowActivation'>
          <ArrowRight style={{ width: 30, height: 30 }} fill={"white"} />
        </div>
        <Headline2 fallbackText={`${calculatedInternalPrice}`} style={{color: "white"}} />
      </div>
      
      {/* red box text */}
      <div>
      <ExplainerText fallbackText={<span style={{color: styleGuide.color7}}>Samme Personal Shopper køb i Tryg Klubben vil kun koste dig ca. <b style={{color: styleGuide.color7}}>{calculatedInternalPrice} efter skat*</b> - næsten halv pris, da varen betales med ubeskattede midler.</span>} />
      <br/>
      <ExplainerTextTiny fallbackText={`Udregning: ${Number(enteredPrice).toLocaleString("da-DK", { style: "currency", currency: "DKK" })} * ((100 - ${Number(enteredPercentage)})/100) = ${Number(enteredPrice * ((100 - enteredPercentage)/100)).toLocaleString("da-DK", { style: "currency", currency: "DKK" })}`} />
      </div>

      {/* grey box */}
      <div style={{ background: "grey", display: "flex", padding: "25px 30px", flexWrap: "wrap", alignItems: "center"}} >
        <ContentNormal fallbackText="Beløb før skat udenfor Tryg Klubben:" style={{color: "white"}} />&nbsp;
        <ContentNormal fallbackText={`${calculatedExternalPrice}`} style={{color: "white"}} />
      </div>
      {/* grey box text */}
      <div>
      <ExplainerText fallbackText={<span style={{color: styleGuide.color7}}>Hvis dit Personal Shopper køb har en pris på <b style={{color: styleGuide.color7}}>{Number(enteredPrice).toLocaleString("da-DK", { style: "currency", currency: "DKK" })}</b> i en almindelig butik, skal du tjene ca. <b style={{color: styleGuide.color7}}>{calculatedExternalPrice} før skat*</b> for at have råd til den.</span>} />
      <br/>
      <ExplainerTextTiny fallbackText={`Udregning: ${Number(enteredPrice).toLocaleString("da-DK", { style: "currency", currency: "DKK" })} / (100 - ${Number(enteredPercentage)}) * 100 = ${Number(enteredPrice / (100 - (enteredPercentage || 0)) * 100).toLocaleString("da-DK", { style: "currency", currency: "DKK" })}`} />
      </div>
    </div>
    <br/>
    {
      !captionText ? null : <ContentLarge fallbackText={captionText} />
    }
    <table style={{maxWidth: "fit-content"}}>
      <tbody>
        {
          rows?.map((r,i) => <tr key={i}>
            {/* <td>&bull;</td> */}
            <td style={{textAlign: "end"}}>{r?.inputValue?.toLocaleString('da-DK')}&nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.valueType}. &nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.inputText} &nbsp;</td>
            <td style={{textAlign: "end"}}>{`${r?.calculatedTaxValue?.toLocaleString('da-DK', { style: "currency", currency: "DKK" })}`}</td>
            </tr>)
        }
      </tbody>
    </table>
  </>
}

export const AdditionalInputFieldsV2 = (props) => {
  const {additionalInput} = props
  const {captionText=" ", data=[], helpText1=""} = additionalInput
  const {brandData, userData, styleGuide, setUserData} = useContext(AppContext)
  const brandPointRatio = brandData?.brandPointRatio || null
  const [rows, setRows] = useState([])

  const defaultPrice = Number(0).toLocaleString("da-DK", { style: "currency", currency: "DKK" })
  const [enteredPercentage, setEnteredPercentage] = useState(userData?.taxPercentage || 0)
  const [enteredPrice, setEnteredPrice] = useState(0)
  const [calculatedInternalPrice, setCalculatedInternalPrice] = useState(defaultPrice)

  const submitTaxPercentage = async() => {
    if(!enteredPercentage) return
    const taxPercentage = enteredPercentage
    const response = await callAPI("/user/saveTaxPercentage", "POST", { body: { taxPercentage: taxPercentage } })
    if (response) {
        setUserData({ ...userData, taxPercentage: taxPercentage })
    }    
  }

  const helpTextBelowRedBox = helpText1 || `Ved køb via ${brandData?.brandName || ''} Klubbens personal shopper-service pålægges et administrationsgebyr. Gebyrets størrelse varierer, men kontakt venligst personal shopper-teamet for en prisvurdering i point for din rejse eller andre indkøb. Du kan herefter vælge at godkende prisen.`

  useEffect(() => {
    if(data?.length){
      setRows(data?.map(a => {
        a.calculatedDKK = Number(a.valueType === 'pt' ? a.inputValue / brandPointRatio : a.inputValue)
        a.calculatedTaxValue = !enteredPercentage ? 'xx.xx' : Number(a.calculatedDKK * (enteredPercentage/100))
        a.inputValue = Number(a.inputValue)
        return a
      }))
    }
  },[enteredPercentage])

  useEffect(() => {
    if(!enteredPrice || !enteredPercentage) { 
      setCalculatedInternalPrice(defaultPrice)
    } else {
      const percentage = enteredPercentage/100
      const intPrice = !enteredPrice || !enteredPercentage ? defaultPrice : Number(enteredPrice * percentage)?.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
      setCalculatedInternalPrice(intPrice)
    }
  },[enteredPercentage, enteredPrice])

  return !data ? null : <>
      <div 
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: 50
      }}
    >
      {/* blue box */}
      <div
        style={{
          display: "flex",
          background: "#235c76" || styleGuide.color16,
          padding: "35px 40px",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast din trækprocent" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPercentage}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPercentage(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="%" style={{color: "white"}} />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast prisen på dit køb" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue=""
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPrice(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="kr" style={{color: "white"}} />
          </div>
        </div>
        <IconButtonMedium
          title="Gem procent til profil"
          style={{ marginLeft: 8, height: 50, width: 50, borderRadius: 20 }}
          onClick={submitTaxPercentage}
          icon={
            <Save
              fill='white'
              style={{ height: 30, width: 30 }}
              stroke="#bf150a"
              strokeWidth="1.5px"
            />
          }
        />
      </div>

      {/* red box */}
      <div style={{ background: "#bf150a", display: "flex", padding: "35px 40px", flexWrap: "wrap", gap: "2rem", alignItems: "center" }} >
        <ContentLarge fallbackText="Du betaler dette beløb i skat, og så er rejsen din" style={{color: "white"}} />
        <div className='arrowActivation'>
          <ArrowRight style={{ width: 30, height: 30 }} fill={"white"} />
        </div>
        <Headline2 fallbackText={`${calculatedInternalPrice}`} style={{color: "white"}} />
      </div>
      
      {/* red box text */}
      <div>
      <ContentNormal fallbackText={helpTextBelowRedBox} />
      <br/>
      {/* Udregning: 2.000 * 0,37 = 740 kr. */}
      <ExplainerText fallbackText={`Udregning: ${Number(enteredPrice).toLocaleString("da-DK", { style: "currency", currency: "DKK" })} * (${Number(enteredPercentage)}/100) = ${Number(enteredPrice * (enteredPercentage/100)).toLocaleString("da-DK", { style: "currency", currency: "DKK" })}`} />
      </div>
    </div>
    <br/>
    <ContentLarge fallbackText={captionText} />
    <table style={{maxWidth: "fit-content"}}>
      <tbody>
        {
          rows?.map((r,i) => <tr key={i}>
            {/* <td>&bull;</td> */}
            <td style={{textAlign: "end"}}>{r?.inputValue?.toLocaleString('da-DK')}&nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.valueType}. &nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.inputText} &nbsp;</td>
            <td style={{textAlign: "end"}}>{`${r?.calculatedTaxValue?.toLocaleString('da-DK', { style: "currency", currency: "DKK" })}`}</td>
            </tr>)
        }
      </tbody>
    </table>
  </>
}


export const AdditionalInputFieldsV3 = (props) => {
  const {additionalInput} = props
  const {captionText=" ", data=[], helpText1=""} = additionalInput
  const helpTextBelowRedBox = helpText1
  const {brandData, userData, styleGuide, setUserData} = useContext(AppContext)
  const brandPointRatio = brandData?.brandPointRatio || null
  const [rows, setRows] = useState([])

  const defaultPrice = Number(0).toLocaleString("da-DK", { style: "currency", currency: "DKK" })
  const [enteredPercentage, setEnteredPercentage] = useState(userData?.taxPercentage || 0)
  const [enteredPrice, setEnteredPrice] = useState(0)
  const [calculatedInternalPrice, setCalculatedInternalPrice] = useState(defaultPrice)

  const submitTaxPercentage = async() => {
    if(!enteredPercentage) return
    const taxPercentage = enteredPercentage
    const response = await callAPI("/user/saveTaxPercentage", "POST", { body: { taxPercentage: taxPercentage } })
    if (response) {
        setUserData({ ...userData, taxPercentage: taxPercentage })
    }    
  }

  useEffect(() => {
    if(data?.length){
      const showExtraFields = data?.some(d => !!d.inputText || !!d.inputValue)
      if(showExtraFields){
        setRows(data?.map(a => {
          //  (Price inserted in “Indtast prisen på dit køb” x 1,15 ) x ”Indtast din trækprocent” / 100
          a.calculatedDKK = Number(a.valueType === 'pt' ? a.inputValue * brandPointRatio : a.inputValue)
          a.calculatedTaxValue = !enteredPercentage ? 'xx.xx' : Number(a.calculatedDKK * (enteredPercentage/100))
          a.inputValue = Number(a.inputValue)
          return a
        }))
      }
    }
  },[enteredPercentage])

  useEffect(() => {
    if(!enteredPrice || !enteredPercentage) { 
      setCalculatedInternalPrice(defaultPrice)
    } else {
      const percentage = enteredPercentage/100
      const intPrice = !enteredPrice || !enteredPercentage 
        ? defaultPrice 
        : Number((enteredPrice * 1.15) * percentage)?.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
      setCalculatedInternalPrice(intPrice)
    }
  },[enteredPercentage, enteredPrice])

  return !data ? null : <>
    <div 
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: 50
      }}
    >
      <Headline2 fallbackText="Ferieberegner" translationKey="_TAX_CAMPAIGN_CALCULATOR_CAPTION_" />
      {/* blue box */}
      <div
        style={{
          display: "flex",
          background: "#4191aa" || styleGuide.color16,
          padding: "35px 40px",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast din trækprocent" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPercentage}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPercentage(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="%" style={{color: "white"}} />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast prisen på dit køb" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPrice}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPrice(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="kr" style={{color: "white"}} />
          </div>
        </div>
        <IconButtonMedium
          title="Gem procent til profil"
          style={{ marginLeft: 8, height: 50, width: 50, borderRadius: 20 }}
          onClick={submitTaxPercentage}
          icon={
            <Save
              fill='white'
              style={{ height: 30, width: 30 }}
              stroke="#bf150a"
              strokeWidth="1.5px"
            />
          }
        />
      </div>

      {/* yellow box */}
      <div style={{ background: "#F9D752", display: "flex", padding: "35px 40px", flexWrap: "wrap", gap: "2rem", alignItems: "center" }} >
        <ContentLarge fallbackText="Du betaler dette beløb i skat, og så er rejsen din" />
        <div className='arrowActivation'>
          <ArrowRight style={{ width: 30, height: 30 }} />
        </div>
        <Headline2 fallbackText={`${calculatedInternalPrice}`} />
      </div>
      <ContentNormal fallbackText={helpTextBelowRedBox} />
    </div>
    <br/>
    {
      !captionText ? null : <ContentLarge fallbackText={captionText} />
    }
    <table style={{maxWidth: "fit-content"}}>
      <tbody>
        {
          rows?.map((r,i) => <tr key={i}>
            {/* <td>&bull;</td> */}
            <td style={{textAlign: "end"}}>{r?.inputValue?.toLocaleString('da-DK')}&nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.valueType}. &nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.inputText} &nbsp;</td>
            <td style={{textAlign: "end"}}>{`${r?.calculatedTaxValue?.toLocaleString('da-DK', { style: "currency", currency: "DKK" })}`}</td>
            </tr>)
        }
      </tbody>
    </table>
  </>
}


export const AdditionalInputFieldsV4 = (props) => {
  const {additionalInput} = props
  const {captionText=" ", data=[], helpText1=""} = additionalInput
  const helpTextBelowRedBox = helpText1
  const {brandData, userData, styleGuide, setUserData} = useContext(AppContext)
  const brandPointRatio = brandData?.brandPointRatio || null
  const [rows, setRows] = useState([])

  const defaultPrice = Number(0).toLocaleString("da-DK", { style: "currency", currency: "DKK" })
  const [enteredPercentage, setEnteredPercentage] = useState(userData?.taxPercentage || 0)
  const [enteredPrice, setEnteredPrice] = useState(0)
  const [calculatedInternalPrice, setCalculatedInternalPrice] = useState(defaultPrice)

  const submitTaxPercentage = async() => {
    if(!enteredPercentage) return
    const taxPercentage = enteredPercentage
    const response = await callAPI("/user/saveTaxPercentage", "POST", { body: { taxPercentage: taxPercentage } })
    if (response) {
        setUserData({ ...userData, taxPercentage: taxPercentage })
    }    
  }

  useEffect(() => {
    if(data?.length){
      const showExtraFields = data?.some(d => !!d.inputText || !!d.inputValue)
      if(showExtraFields){
        setRows(data?.map(a => {
          //  (Price inserted in “Indtast prisen på dit køb” x 1,15 ) x ”Indtast din trækprocent” / 100
          a.calculatedDKK = Number(a.valueType === 'pt' ? a.inputValue * brandPointRatio : a.inputValue)
          a.calculatedTaxValue = !enteredPercentage ? 'xx.xx' : Number(a.calculatedDKK * (enteredPercentage/100))
          a.inputValue = Number(a.inputValue)
          return a
        }))
      }
    }
  },[enteredPercentage])

  useEffect(() => {
    if(!enteredPrice || !enteredPercentage) { 
      setCalculatedInternalPrice(defaultPrice)
    } else {
      const percentage = enteredPercentage/100
      const intPrice = !enteredPrice || !enteredPercentage 
        ? defaultPrice 
        : Number((enteredPrice * 1.15) * percentage)?.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
      setCalculatedInternalPrice(intPrice)
    }
  },[enteredPercentage, enteredPrice])

  return !data ? null : <>
    <div 
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: 50
      }}
    >
      <Headline2 fallbackText="Ferieberegner" translationKey="_TAX_CAMPAIGN_CALCULATOR_CAPTION_" />
      {/* blue box */}
      <div
        style={{
          display: "flex",
          background: "#4191aa" || styleGuide.color16,
          padding: "35px 40px",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast din trækprocent" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPercentage}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPercentage(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="%" style={{color: "white"}} />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <ContentLarge fallbackText="Indtast prisen på dit køb" style={{color: "white", fontWeight: 400}} />
          <div style={{ display:"flex", gap: 5 }}>
            <Input
              style={{background: "white", border:"none", borderRadius: 8, fontSize: 20, padding: 10}}
              defaultValue={enteredPrice}
              type="number"
              inputProps={{ style: {textAlign: "right"} }}
              onChange={(e) => setEnteredPrice(Number(e?.target?.value || 0))}
              disableUnderline={true}
            />
            <Headline2 fallbackText="kr" style={{color: "white"}} />
          </div>
        </div>
        <IconButtonMedium
          title="Gem procent til profil"
          style={{ marginLeft: 8, marginTop: 12, height: 50, width: 50, borderRadius: 20 }}
          onClick={submitTaxPercentage}
          icon={
            <Save
              fill='white'
              style={{ height: 30, width: 30 }}
              stroke="#bf150a"
              strokeWidth="1.5px"
            />
          }
        />
      </div>

      {/* yellow box */}
      <div style={{ background: "#9cd9d0", display: "flex", padding: "35px 40px", flexWrap: "wrap", gap: "2rem", alignItems: "center" }} >
        <ContentLarge fallbackText="Du betaler dette beløb i skat, og så er rejsen din" />
        <div className='arrowActivation'>
          <ArrowRight style={{ width: 30, height: 30 }} />
        </div>
        <Headline2 fallbackText={`${calculatedInternalPrice}`} />
      </div>
      <ContentNormal fallbackText={helpTextBelowRedBox} />
    </div>
    <br/>
    {
      !captionText ? null : <ContentLarge fallbackText={captionText} />
    }
    <table style={{maxWidth: "fit-content"}}>
      <tbody>
        {
          rows?.map((r,i) => <tr key={i}>
            {/* <td>&bull;</td> */}
            <td style={{textAlign: "end"}}>{r?.inputValue?.toLocaleString('da-DK')}&nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.valueType}. &nbsp;</td>
            <td style={{textAlign: "end"}}>{r?.inputText} &nbsp;</td>
            <td style={{textAlign: "end"}}>{`${r?.calculatedTaxValue?.toLocaleString('da-DK', { style: "currency", currency: "DKK" })}`}</td>
            </tr>)
        }
      </tbody>
    </table>
  </>
}